import { useEffect, useState } from 'react';
import { professionalCost, professionalPreference, setProfessionalPreference, useProfessionalAvailability } from '../lib/professional.js';

export function ProfessionalSettings({ userId }: { userId: string }) {
  const availability = useProfessionalAvailability(userId);
  const [choice, setChoice] = useState({ userId, enabled: professionalPreference(userId) });
  useEffect(() => { setChoice({ userId, enabled: professionalPreference(userId) }); }, [userId]);
  if (!availability?.eligible) return null;
  const enabled = choice.userId === userId && choice.enabled && availability.configured;
  return <section className="card stack" aria-label="Professional voice settings">
    <h2>Professional voice</h2>
    <label className="switch">
      <input type="checkbox" role="switch" aria-label="Professional voice" checked={enabled} disabled={!availability.configured} onChange={event => {
        setProfessionalPreference(userId, event.target.checked);
        setChoice({ userId, enabled: event.target.checked });
      }} />
      <span className="switch-track" />
      <span>Professional voice {enabled ? 'on' : 'off'}</span>
    </label>
    {!availability.configured ? <p className="muted">Not available yet. The server needs verified voice pricing and its other voice settings.</p> : <p className="muted">{professionalCost((availability.voiceMicrosPerSecond ?? 0) * 60)} per minute of continuous audio. Backend usage is separate.</p>}
    <p className="small muted">Your opt-in on this device opens the paid session options in a call. Every call starts with Professional voice off. Turn it on in the call after agreeing to the session limit, audio disclosure and charge. Changing this setting starts no paid session.</p>
  </section>;
}
